// Calendar helpers for scheduling requests (Google Calendar + .ics download).

export const dateOnly = (dt) => (dt || "").slice(0, 10);

const pad = (n) => String(n).padStart(2, "0");

// Default appointment time: scheduled_date at 9am, else tomorrow 9am (local, datetime-local format).
export const defaultWhen = (b) => {
  if (b?.scheduled_date) return `${dateOnly(b.scheduled_date)}T09:00`;
  const d = new Date(Date.now() + 864e5);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T09:00`;
};

export const buildEvent = (b, whenLocal, durMin = 60) => {
  const start = new Date(whenLocal);
  const end = new Date(start.getTime() + durMin * 60000);
  const title = `${b.service || "HVAC Appointment"} — ${b.name || "Customer"}`;
  const description = [
    b.name && `Customer: ${b.name}`,
    b.phone && `Phone: ${b.phone}`,
    b.email && `Email: ${b.email}`,
    b.service && `Service: ${b.service}`,
    b.message && `Notes: ${b.message}`,
  ].filter(Boolean).join("\n");
  return { title, start, end, description, location: b.address || "" };
};

const toUtcStamp = (d) =>
  `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}00Z`;

export const googleCalendarUrl = (ev) => {
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: ev.title,
    dates: `${toUtcStamp(ev.start)}/${toUtcStamp(ev.end)}`,
    details: ev.description,
    location: ev.location,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const downloadIcs = (ev, filename = "appointment.ics") => {
  const esc = (s) => String(s || "").replace(/\\/g, "\\\\").replace(/\n/g, "\\n").replace(/,/g, "\\,").replace(/;/g, "\\;");
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Aquila Air & Heating//EN",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@aquilaairandheating.com`,
    `DTSTAMP:${toUtcStamp(new Date())}`,
    `DTSTART:${toUtcStamp(ev.start)}`,
    `DTEND:${toUtcStamp(ev.end)}`,
    `SUMMARY:${esc(ev.title)}`,
    `DESCRIPTION:${esc(ev.description)}`,
    `LOCATION:${esc(ev.location)}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
};
